import { CircularProgress, Container, Stack, Typography } from "@mui/material";
import type React from "react";

export interface LoadingPageProps {
  loadingText?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ loadingText }) => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Stack
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        spacing={2}
      >
        <CircularProgress color="primary" />
        {loadingText && (
          <Typography variant="body1" color="textSecondary">
            {loadingText}
          </Typography>
        )}
      </Stack>
    </Container>
  );
};
